import type { TagProps } from "antd";
import Tag from "antd/es/tag";
import type { AudienceGroupStatus } from "../../../shared";

const AUDIENCE_STATUS_MAP: Record<
	AudienceGroupStatus,
	{
		label: string;
		tagColor: TagProps["color"];
	}
> = {
	IN_PROGRESS: { label: "作成中", tagColor: "#fcbf49" },
	READY: { label: "完成", tagColor: "#06d6a0" },
	FAILED: { label: "エラー", tagColor: "#ff6b6b" },
	EXPIRED: { label: "期限切れ", tagColor: "#f77f00" },
	INACTIVE: { label: "無効", tagColor: "#38a3a5" },
	ACTIVATING: { label: "有効化中", tagColor: "#52b788" },
};

export const renderAudienceStatusTag = (statusValue: AudienceGroupStatus) => {
	const { label, tagColor } = AUDIENCE_STATUS_MAP[statusValue];
	return (
		<Tag color={tagColor} className="mr-0">
			{label}
		</Tag>
	);
};
